import ViewAllPoliciesLink from
    '@/components/ReturnPolicyDialog/ViewAllPoliciesLink'

require('./index.scss')

import { useState } from 'react'
import { useSelector } from 'react-redux'

import Dialog from '@/components/Dialog'
import {
  isMarketplaceSelector,
  isPrintAssetSelector,
  returnPolicyModalHeaderSelector,
} from '@/selectors'
import { translate } from '@/utils/translations'

import BulkStoreContent from './BulkStoreContent'
import Logo from './Logo'
import RegularStoreContent from './RegularStoreContent'
import RegularStoreContentPrint from './RegularStoreContentPrint'
import Trigger from './Trigger'
import WatkinsGraphic from './WatkinsGraphic'

const ReturnPolicyModal = () => {
  const isBulkEnabled = useSelector(state => state.currentRegion.bulkEnabled)
  const returnPolicyModalHeader = useSelector(returnPolicyModalHeaderSelector)
  const [isShowing, setIsShowing] = useState(false)
  const isBulkIntegrationEnabled = useSelector(
    state => state.featureFlags.bulkIntegrationEnabled
  )
  const isPrintAsset = useSelector(isPrintAssetSelector)
  const isMarketplace = useSelector(isMarketplaceSelector)
  const printVariantLabel = isMarketplace
    ? translate('common.print_variants.marketplace')
    : translate('common.kind.print')
  const heading = isPrintAsset
    ? `${returnPolicyModalHeader} - ${printVariantLabel}`
    : returnPolicyModalHeader

  return (
    <Dialog
      heading={heading}
      id='return-policy-modal'
      isShowing={isShowing}
      onChangeShow={setIsShowing}
      trigger={<Trigger onClick={() => setIsShowing(true)} />}
    >
      {
        isPrintAsset
          ? <RegularStoreContentPrint />
          : isBulkEnabled
          ? <BulkStoreContent />
          : <RegularStoreContent />
      }
      {(isBulkIntegrationEnabled || isPrintAsset) ? <ViewAllPoliciesLink /> : (
        <>
          <WatkinsGraphic />
          <Logo />
        </>
      )}
    </Dialog>
  )
}

export default ReturnPolicyModal
